import {
  ShopCardProps,
  TabbedCollectionProps,
} from "@bluebottlecoffee/design-system/components";
import { DereferencedTabbedCollection as Schema } from "../sanity/tabbed-collection-queries";
import { toImageProps } from "./image";
import { toLinkProps } from "./link";

type TabInfoPanel = NonNullable<Schema["tabs"][number]["infoPanel"]>;

function hasCompleteInfoPanel(
  infoPanel: TabInfoPanel | undefined,
): infoPanel is TabInfoPanel {
  return Boolean(
    infoPanel?.image?.source && infoPanel.heading && infoPanel.subheading,
  );
}

/**
 * Builds TabbedCollection props. Product cards are resolved from Algolia at
 * build time (one list per tab, aligned by index) and injected here, mirroring
 * how the subscription collections preview module is fed.
 */
export function toTabbedCollectionProps(
  data: Schema,
  region: string,
  lang: string,
  productsByTab: ShopCardProps[][],
): TabbedCollectionProps {
  const cta = data.cta && toLinkProps(data.cta, region, lang);

  return {
    ...(data.bgColor && { bgColor: data.bgColor }),
    ...(cta && { cta: { text: cta.text, link: cta.url, level: "primary" } }),
    tabs: data.tabs.map((tab, index) => ({
      id: tab._key,
      label: tab.label[lang],
      ...(hasCompleteInfoPanel(tab.infoPanel) && {
        infoPanel: {
          image: toImageProps(tab.infoPanel.image, lang),
          heading: tab.infoPanel.heading[lang],
          subheading: tab.infoPanel.subheading[lang],
          ...(tab.infoPanel.textColor && {
            textColor: tab.infoPanel.textColor,
          }),
        },
      }),
      products: productsByTab[index] ?? [],
    })),
  };
}
